export const openCmpDrawer = () => {
   if (window.Osano.cm.countryCode === 'us') {
     window.Osano.cm.showDoNotSell();
   } else {
     window.Osano.cm.showDrawer();
   }
};